export default __webpack_public_path__ + "static/media/Vector2.65612209.svg";